<template>
  <div class="lang-selector" v-if="showSelector" @click.stop="toggleMenu">
    <i class="icon smarket icons-language"></i>
    <div class="lang-menu" v-show="menuShow">
      <a
        href="javascript:;"
        v-for="lang in langs"
        :key="lang"
        @click.stop="selectLang(lang)"
        :class="{ active: lang === currentLang }"
        >{{ langDisplayName(lang) }}</a
      >
    </div>
  </div>
</template>

<script>
const DISPLAY_NAMES = {
  zh_CN: "简体中文",
  en_US: "English",
  zh_TW: "繁體中文",
};
export default {
  name: "LangSelector",
  data() {
    return { menuShow: false };
  },
  computed: {
    langs() {
      return this.$store.state.i18n.langs;
    },
    currentLang() {
      return this.$store.state.i18n.currentLang;
    },
    showSelector() {
      return this.$store.getters["i18n/showLangSelector"];
    },
  },
  methods: {
    toggleMenu() {
      this.menuShow = !this.menuShow;
    },
    selectLang(lang) {
      this.menuShow = false;
      if (lang !== this.currentLang) {
        this.$store.commit("i18n/SET_CURRENT_LANG", lang);
      }
    },
    langDisplayName(lang) {
      return DISPLAY_NAMES[lang] || lang;
    },
    handleOutsideClick(e) {
      if (this.$el && !this.$el.contains(e.target)) {
        this.menuShow = false;
      }
    },
  },
  mounted() {
    document.addEventListener("click", this.handleOutsideClick);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleOutsideClick);
  },
};
</script>

<style scoped>
.lang-selector {
  position: relative;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  font-size: 18px;
  color: #666;
  padding: 0 8px;
}
.lang-selector:hover {
  color: #1890ff;
}
.lang-menu {
  position: absolute;
  top: 100%;
  right: 0;
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  min-width: 100px;
  z-index: 100;
  padding: 4px 0;
}
.lang-menu a {
  display: block;
  padding: 6px 12px;
  font-size: 13px;
  color: #333;
  text-decoration: none;
}
.lang-menu a:hover {
  background: #f5f5f5;
}
.lang-menu a.active {
  color: #1890ff;
  font-weight: bold;
}
</style>
